<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Account Transactions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Account Transactions",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Account Transactions",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },        
        {
          key: "account",
          sortable: true,
          label: "ACCOUNT NAME",
        },
        {
          key: "reference",
          sortable: true,
          label: "REFERENCE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "dr",
          sortable: true,
          label: "DEBIT AMOUNT",
        },
        {
          key: "cr",
          sortable: true,
          label: "CREDIT AMOUNT",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "ADDED ON",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        },
      ],
      total_credit:0,
      total_debit:0,
      // edit category
      editdata: {
        amount: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
      },

      deletedata:{
        id:""
      },

      creditError: "",
      debitError: "",
      amountError: "",
      TypeError:"",      
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("coa", ["TransactionDetails"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.TransactionDetails ? this.TransactionDetails.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.TransactionDetails ? this.TransactionDetails.length : 1;
  },
  updated(){
    let total_credit = 0;
    let total_debit = 0;
      // let total_paid = 0;
      if(this.TransactionDetails){
        this.TransactionDetails.forEach((item)=>{
          total_credit = total_credit+parseInt(item.cr);
          total_debit = total_debit+parseInt(item.dr);
        });
        this.total_debit = total_debit;
        this.total_credit = total_credit;
      }
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchTransactions: "coa/fetchTransactionDetails",
      EditTransactions: "coa/editTransactionDetails",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    resetEditTrans() {
      this.editdata.amount = "";
      this.editdata.date = "";
      this.amountError = "";
      this.modal_id = "";
    },

    showEditModal(data) {
      this.editdata.id = data.item.id;
      this.editdata.amount = data.item.cr > 0?data.item.cr:data.item.dr;
    },

    showDeleteModal(data){
      this.deletedata.id = data.item.id;
    },

    editTransaction(){
      this.EditTransactions(this.editdata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchTransactions(this.$route.params.id);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">      
      <div class="col-12">
        <div class="card">
          <div class="row mt-2 px-2">
              <div class="col-md-9"></div>
              <div class="col-md-3" align="right">
                <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>          
          </div>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="TransactionDetails ? TransactionDetails : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(account)="data">
                  <div v-if="data.item.source == 2 && data.item.account_id != ''">
                    <router-link :to="`/supplierbalance_details/${data.item.account.id}`">
                      {{ (data.item.account.name) }}
                    </router-link>
                  </div>
                  <div v-if="data.item.source == 1 && data.item.account_id != ''">
                    <router-link :to="`/customer/balance_details/${data.item.account.id}`">
                      {{ (data.item.account.name) }}
                    </router-link>
                  </div>
                  
                  <div v-if="data.item.source != 0 && data.item.account_id == ''">
                      {{ (data.item.account) }}
                  </div>  
                  <div v-if="data.item.source == 0 && data.item.reference1 != 28 && data.item.reference1 != 29">
                      {{ (data.item.accounts.name) }}
                  </div>   
                  <div v-if="data.item.reference1 == 28 && data.item.vehicle != ''">
                    {{ data.item.vehicle.make }} - {{ data.item.vehicle.plate_number }}
                  </div>
                  <div v-if="data.item.reference1 == 29 && data.item.vehicle != ''">
                    {{ data.item.vehicle.name }}
                  </div>                 
                </template>
                <template #cell(dr)="data">
                  {{ thousandSeperator(data.item.dr) }}
                </template>
                <template #cell(cr)="data">
                  {{ thousandSeperator(data.item.cr) }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group v-if="data.item && data.item.type == 1">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-transaction-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-transaction-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  </b-button-group>
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-4">
                    <h5>Total Debit: <span class="text-primary">{{thousandSeperator(total_debit)}}</span></h5>
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-4">
                    <h5>Total Credit: <span class="text-danger">{{thousandSeperator(total_credit)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader v-if="!TransactionDetails"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- edit modal starts -->
            <b-modal id="edit-transaction-modal" hide-footer @hidden="resetEditTrans">
              <template #modal-title> Edit Account {{ editdata.name }}</template>              
              <div class="form-group mb-3">
                <label>Amount</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.amount"
                    @input="resetErrors()"
                    placeholder="Enter Amount"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>  
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="editdata.date"
                  />
                </div>
              </div> 
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-transaction-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editTransaction('edit-transaction-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="AccountSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-transaction-modal"
              hide-footer
              @hidden="resetDeleteAcc"
            >
              <template #modal-title> Delete Transaction {{ deletedata.name }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this transaction? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-transaction-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteTransaction('delete-transaction-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="AccountSaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
